/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { CommunityDto } from './community.dto';

export const CommunityMapper = entity<CommunityDto>();
